<div>
  <p-button severity="secondary"
            class="flex"
            styleClass="h-[2rem] w-[3.6875rem] !px-0 !py-0 !gap-1 font-medium text-[0.75rem] leading-[150%] !text-(--p-other-blue-120) !border-0 !bg-transparent"
            (onClick)="$event.stopPropagation(); popover.toggle($event); propagateEventClickManually($event);">
    <div class="flex flex-col items-start max-w-[6.125rem]">
      <span class="truncate w-full text-left text-[0.75rem]">{{(value() | localeNumber) || ('@@shared-set__text' | translate)}}</span>
    </div>

    <ng-container
      [ngTemplateOutlet]="popoverArrows"
      [ngTemplateOutletContext]="{ popover }"></ng-container>
  </p-button>

  <p-popover #popover
             autoZIndex="false"
             dismissable="true"
             [styleClass]="'!rounded-[0.5rem] before:hidden after:hidden ' + popoverStyleClass()">
    <div class="w-[20rem] flex flex-col gap-1 justify-start px-3 py-1">
      <div class="h-[2.125rem] flex items-center justify-between text-[0.75rem] font-medium text-(--p-other-blue-120)">
        <div translate="@@shared-env-noise__text"></div>

        <div translate="@@shared-logger__serial-number" [translateParams]="{I18N_VAR_SERIAL: serialNo()}"></div>
      </div>

      <form [formGroup]="formGroup" autocomplete="off" class="flex flex-col gap-[1.25rem] w-full">
<!--        // TODO use pInputNumber for correct locale separator (as option) -->
        <input aria-autocomplete="none"
               [placeholder]="'@@shared-enter-env-noise__placeholder' | translate"
               type="number"
               pInputText
               class="w-full h-[2.75rem] !text-[0.875rem] !font-medium placeholder:!text-(--p-gray-200)"
               formControlName="envNoiseDecibel"
               aria-describedby="envNoiseDecibel"/>
      </form>

      <div class="h-[3rem] flex items-center justify-end gap-1 shrink-0">
        <p-button [label]="'@@shared-cancel__text' | translate"
                  styleClass="h-[2rem] !px-4"
                  [outlined]="true" size="small"
                  (onClick)="popover.hide()"/>

        <p-button [label]="'@@shared-save-changes__text' | translate"
                  styleClass="h-[2rem] !px-4"
                  [disabled]="formGroup.invalid"
                  size="small" (onClick)="onSubmit()"/>
      </div>
    </div>
  </p-popover>
</div>


<ng-template #popoverArrows let-popover="popover">
  <svg-icon src="icons/icon-dropdown-arrow-up.svg" name="icon-dropdown-arrow-up"
            [ngClass]="{'hidden': !popover.overlayVisible}"
            class="!text-(--p-primary-300) pb-[0.125rem] shrink-0"></svg-icon>
  <svg-icon src="icons/icon-dropdown-arrow-down.svg" name="icon-dropdown-arrow-down"
            [ngClass]="{'hidden': popover.overlayVisible}"
            class="!text-(--p-gray-300) pb-[0.125rem] shrink-0"></svg-icon>
</ng-template>
